import { chakra } from '@chakra-ui/react';

import { ModalWrapper } from '../../../../../components/modal-wrapper';

export const PopoverModalWrapper = chakra(ModalWrapper, {
    baseStyle: {
        flexDirection: 'column',
        padding: 0,
        overflow: 'hidden'
    }
});
